export default __webpack_public_path__ + "static/media/logoWhite.2911a8f5.png";